<!-- <app-main-carousel [slides]="slides"></app-main-carousel>  -->

<!-- <div fxLayout="row wrap" class="info-bar">
    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">
        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">
            <mat-icon class="mat-icon-xlg text-muted m-0">card_giftcard</mat-icon>
            <div class="content">
                <p>BONUS PLUS</p> 
                <span class="text-muted m-0">Make fun of shopping and collect bonuses</span>
            </div> 
        </mat-card> 
    </div>
    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> 
        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">
            <mat-icon class="mat-icon-xlg text-muted m-0">local_shipping</mat-icon>
            <div class="content">
                <p>FREE SHIPPING</p> 
            <span class="text-muted m-0">Free shipping on all orders over {{storeDetails['currency']}}{{storeDetails['delivery_upper_limit']}}</span>
            </div> 
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> 
        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">
            <mat-icon class="mat-icon-xlg text-muted m-0">monetization_on</mat-icon>
            <div class="content">
                <p>MONEY BACK GUARANTEE</p> 
                <span class="text-muted m-0">30 Days money return guarantee</span>
            </div> 
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> 
        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">
            <mat-icon class="mat-icon-xlg text-muted m-0">history</mat-icon>
            <div class="content">
                <p>ONLINE SUPPORT 24/7</p> 
                <span class="text-muted m-0">Call us: {{storeDetails['phone'] |  phone: 'US'}}</span>
            </div> 
        </mat-card>
    </div>
</div> -->

<!-- <app-banners [banners]="banners"></app-banners> -->

<div class="products-tabs">
    <!-- Cut-Off Time Message For Desktop -->
    <div fxLayout="row" fxLayoutAlign="flex-start center" fxShow="false" fxShow.gt-sm
        *ngIf="router.url === '/shop' && isShowCutOffMessage && !!showMessage && !!isLoggedIn">
        <div class="cut-off-message-container mb-5px" fxLayout="row" fxLayoutAlign="space-between center"
            fxLayoutGap="5px" *ngIf="!!orderCutOff">
            <span class="message">
                Order cut-off time is {{orderCutOff}}
            </span>
            <i class="material-icons close-button" data-icon="close" (click)="closeCutOffMessage()"></i>
            <!-- <mat-icon class="close-button" (click)="closeCutOffMessage()">close</mat-icon> -->
        </div>
        <br>
    </div>
    <!-- End -->
    <div fxLayout="row" fxLayoutAlign="center center" fxShow="false" fxShow.lt-md
        *ngIf="router.url === '/shop' &&  isShowCutOffMessage && !!showMessage && !!isLoggedIn">
        <div class="cut-off-message-container mt-1 mb-5px" fxLayout="row" fxLayoutAlign="space-between center"
            fxLayoutGap="5px" *ngIf="!!orderCutOff">
            <span class="message">
                Order cut-off time is {{orderCutOff}}
            </span>
            <i class="material-icons close-button" data-icon="close" (click)="closeCutOffMessage()"></i>
            <!-- <mat-icon class="close-button" (click)="closeCutOffMessage()">close</mat-icon> -->
        </div>
        <br>
    </div>
    <mat-tab-group mat-stretch-tabs>

        <mat-tab>
            <ng-template mat-tab-label>
                <h1 class="visually-hidden">Featured Products</h1>
                Featured Products
            </ng-template>
            <div *ngIf="(featuredProducts.length === 0 && pageLoaded === false) || !!platformServer"
                fxLayout="row wrap">
                <div *ngFor="let item of array">
                    <div class="fb-item">
                        <div class="first-section-wrapper">
                            <div class="gravatar">
                                <ngx-skeleton-loader appearance="circle"
                                    [theme]="{ width: '80px', height: '80px', 'border-radius': '10px' }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="gravatar-title">
                                <div>
                                    <ngx-skeleton-loader [theme]="{
                                width: '200px',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                            }"></ngx-skeleton-loader>
                                </div>
                                <div>
                                    <ngx-skeleton-loader
                                        [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="second-section-wrapper">
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                            width: '80%',
                            'border-radius': '0',
                            height: '15px',
                            'margin-bottom': '10px'
                            }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                            width: '90%',
                            'border-radius': '0',
                            height: '15px',
                            'margin-bottom': '10px'
                            }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                            width: '60%',
                            'border-radius': '0',
                            height: '15px',
                            'margin-bottom': '10px'
                            }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <app-products-carousel *ngIf="!!showMessage && featuredProducts.length > 0" [featuredCount]="featuredCount"
                [products]="featuredProducts" [store]="storeDetails" [paginationDetails]="paginationDetails">
            </app-products-carousel>
            <div *ngIf="featuredProducts.length === 0 && pageLoaded === true && !!showMessage" fxLayout="row wrap"
                fxLayoutAlign="center">
                *No Records Found
            </div>
        </mat-tab>
        <!-- <mat-tab label="On Sale">
           <app-products-carousel [products]="onSaleProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab>
        <mat-tab label="Top Rated">
            <app-products-carousel [products]="topRatedProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab>
        <mat-tab label="New Arrivals">
            <app-products-carousel [products]="newArrivalsProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab> -->
    </mat-tab-group>


</div>
<ng-container *ngIf="!!featureTags && featureTags['sf_show_featured_products_issue']">
    <mat-paginator [hidePageSize]="true" [length]="featuredCount" (page)="getFeaturedData($event)" [pageSize]="12">
    </mat-paginator>
</ng-container>
<ng-container *ngIf="!!featureTags && !featureTags['sf_show_featured_products_issue']">
    <mat-paginator [hidePageSize]="true" [length]="featuredCount" (page)="getFeaturedData($event)" [pageSize]="9">
    </mat-paginator>
</ng-container>
<div class="products-tabs">

    <mat-tab-group mat-stretch-tabs>

        <!-- <mat-tab label="Featured">           
           <app-products-carousel [products]="featuredProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab>
        <mat-tab label="On Sale">
           <app-products-carousel [products]="onSaleProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab>
        <mat-tab label="Top Rated">
            <app-products-carousel [products]="topRatedProducts" [store] = "storeDetails"></app-products-carousel>
        </mat-tab> -->
        <mat-tab>
            <ng-template mat-tab-label>
                <h1 class="visually-hidden">New Arrivals</h1>
                New Arrivals
            </ng-template>
            <div *ngIf=" (newArrivalsProducts.length === 0 && pageLoaded === false) ||  !!platformServer"
                fxLayout="row wrap">
                <div *ngFor="let item of array">
                    <div class="fb-item">
                        <div class="first-section-wrapper">
                            <div class="gravatar">
                                <ngx-skeleton-loader appearance="circle"
                                    [theme]="{ width: '80px', height: '80px', 'border-radius': '10px' }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="gravatar-title">
                                <div>
                                    <ngx-skeleton-loader [theme]="{
                                    width: '200px',
                                    'border-radius': '0',
                                    height: '15px',
                                    'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                                </div>
                                <div>
                                    <ngx-skeleton-loader
                                        [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="second-section-wrapper">
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '80%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '90%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                            <div class="wrapper">
                                <ngx-skeleton-loader [theme]="{
                                width: '60%',
                                'border-radius': '0',
                                height: '15px',
                                'margin-bottom': '10px'
                                }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <app-products-carousel *ngIf="!!showMessage && newArrivalsProducts.length > 0"
                [newArrivalCount]="newArrivalCount" [paginationDetails]="paginationDetails"
                [products]="newArrivalsProducts" [store]="storeDetails">
            </app-products-carousel>
            <div *ngIf=" newArrivalsProducts.length === 0  && pageLoaded === true && !!showMessage" fxLayout="row wrap"
                fxLayoutAlign="center">
                *No Records Found
            </div>
        </mat-tab>
    </mat-tab-group>


</div>
<ng-container *ngIf="!!featureTags && featureTags['sf_show_featured_products_issue']">
<mat-paginator [hidePageSize]="true" [length]="newArrivalCount" (page)="getNewArrivalData($event)" [pageSize]="12">
</mat-paginator>
</ng-container>
<ng-container *ngIf="!!featureTags && !featureTags['sf_show_featured_products_issue']">
<mat-paginator [hidePageSize]="true" [length]="newArrivalCount" (page)="getNewArrivalData($event)" [pageSize]="9">
</mat-paginator>
</ng-container>
<!-- <app-brands-carousel [brands]="brands"></app-brands-carousel>  -->